'use client';

import styles from './MeasurementPlan.module.scss';
import { AlertCircle } from 'lucide-react';

interface ErrorStateProps {
  isEn: boolean;
  onRetry: () => void;
}

export function ErrorState({ isEn, onRetry }: ErrorStateProps) {
  return (
    <div className={styles.errorBox} role="alert">
      <AlertCircle size={24} />
      <p>
        {isEn
          ? 'Could not generate the plan. Please try again.'
          : 'Impossible de générer le plan. Veuillez réessayer.'}
      </p>
      <button type="button" className={styles.retryButton} onClick={onRetry}>
        {isEn ? 'Try again' : 'Réessayer'}
      </button>
    </div>
  );
}
